export default "__VITE_ASSET__05de4fd4__"